// React Imports
import React, { useState } from "react";

// Internationalization Import
import i18n from "i18next";

// Internal Imports
import { fetchWrapper } from "../../helpers/fetchwrapper";
import { IUserDocument } from "../../Models/IUserDocument";

import { baseUrl } from "../../helpers/constants";
import {
  Button,
  Dialog,
  DialogActions,
  DialogBody,
  DialogContent,
  DialogSurface,
  DialogTitle,
} from "@fluentui/react-components";
import { DeleteRegular } from "@fluentui/react-icons";

// Props
interface IDeleteMediathekDocumentDialogProps {
  isDialogOpen: boolean;
  document: IUserDocument | undefined;
  onDismiss: any;
  onDelete: any;
}

// Function
function DeleteMediathekDocumentDialog(
  props: IDeleteMediathekDocumentDialogProps,
) {
  /* const deleteDialogContentProps = {
    type: DialogType.largeHeader,
    title: i18n.t<string>("deleteDocument"),
    closeButtonAriaLabel: i18n.t<string>("cancel"),
    subText: props.document
      ? i18n
          .t("deleteDocumentText")
          .replace(
            "{name}",
            props.document.displayDocFileName
              ? props.document.displayDocFileName
              : props.document.description,
          )
      : "",
  }; */

  const deleteDocument = () => {
    fetchWrapper
      .getWithAuth(
        `${baseUrl}/api/documents/delete?id=${
          props.document ? props.document.userObjectGuid : ""
        }`,
      )
      .then((data: any) => {
        props.onDelete();
      });
  };

  return (
    <Dialog open={props.isDialogOpen}>
      <DialogSurface>
        <DialogBody>
          <DialogTitle>{i18n.t<string>("deleteDocument")}</DialogTitle>
          <DialogContent>
            {props.document
              ? i18n
                  .t("deleteDocumentText")
                  .replace(
                    "{name}",
                    props.document.displayDocFileName
                      ? props.document.displayDocFileName
                      : props.document.description,
                  )
              : ""}
          </DialogContent>
          <DialogActions>
            <Button
              appearance="primary"
              onClick={() => deleteDocument()}
              icon={<DeleteRegular />}
            >
              {i18n.t<string>("delete")}
            </Button>
            <Button onClick={() => props.onDismiss()}>
              {i18n.t<string>("cancel")}
            </Button>
          </DialogActions>
        </DialogBody>
      </DialogSurface>
    </Dialog>
  );
}

// Export Function
export default DeleteMediathekDocumentDialog;
